import { useNavigate } from 'react-router-dom';
import { ArrowSquareOut, FolderSimple, Receipt, UploadSimple } from '@phosphor-icons/react';
import { ImmoButton, LeerZustand } from '../../../../../components/immobilien/ui';
import { dokumentOeffnenUrl } from '../../../../../lib/dokumente/dokumentLink';
import { deDatum } from '../../../../../lib/immobilien/objektDetail';
import { kontaktName } from '../../../../../lib/objekte/objektKontakte';
import { useEinheitSeite } from '../EinheitSeitenKontext';

/**
 * „Dokumente“ der Einheit und ihrer Mieter. Klick wie bisher: gehört das Dokument zu einer Rechnung
 * der Einheit, öffnet sich die Rechnung (Ticket #428), sonst die Datei. Hochladen: Dokumentenbereich.
 */
export function DokumenteBereich() {
  const { daten } = useEinheitSeite();
  const navigate = useNavigate();
  const zumBereich = () => navigate(`/admin/dokumente?objekt=${encodeURIComponent(daten.objekt.id)}`);
  const rechnungJeDokument = new Map(daten.rechnungen.filter(r => r.dokument_id).map(r => [r.dokument_id as string, r.id]));
  const mieterName = new Map(daten.mieter.map(m => [m.id, kontaktName(m)]));

  if (daten.dokumente.length === 0) {
    return (
      <LeerZustand icon={FolderSimple} titel="Noch keine Dokumente" text="Dokumente der Mieter dieser Einheit erscheinen hier, sobald sie im Dokumentenbereich zugeordnet sind.">
        <ImmoButton art="akzent" icon={UploadSimple} onClick={zumBereich}>Im Dokumentenbereich hochladen</ImmoButton>
      </LeerZustand>
    );
  }

  return (
    <>
      <div className="flex items-center justify-between flex-wrap" style={{ gap: 10 }}>
        <span style={{ fontSize: 13, color: 'var(--ink3)' }}>{daten.dokumente.length} {daten.dokumente.length === 1 ? 'Dokument' : 'Dokumente'} der Mieter dieser Einheit</span>
        <ImmoButton art="akzent" groesse={40} icon={UploadSimple} onClick={zumBereich}>Hochladen</ImmoButton>
      </div>
      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(min(260px,100%),1fr))', gap: 10 }}>
        {daten.dokumente.map(d => {
          const rechnungId = rechnungJeDokument.get(d.id);
          const url = dokumentOeffnenUrl(d);
          const oeffnen = rechnungId ? () => navigate(`/admin/rechnungen/${encodeURIComponent(rechnungId)}`)
            : url ? () => window.open(url, '_blank', 'noopener,noreferrer') : undefined;
          const endung = (d.datei_name?.includes('.') ? d.datei_name.split('.').pop() : (d.datei_typ ?? '').split('/').pop()) || 'DOK';
          const zuordnung = d.mieter_id ? mieterName.get(d.mieter_id) ?? 'Mieter' : '';
          return (
            <button key={d.id} type="button" onClick={oeffnen} disabled={!oeffnen}
              title={rechnungId ? 'Zur Rechnung' : url ? 'Datei öffnen' : 'Nur im Dokumentenbereich erreichbar'}
              className={`immo-innen flex items-center text-left ${oeffnen ? 'immo-hover-flaeche cursor-pointer' : 'cursor-default'}`}
              style={{ borderRadius: 20, padding: 14, gap: 12, border: 'none', color: 'var(--ink)', opacity: oeffnen ? 1 : 0.6 }}>
              <span className="flex items-end justify-center shrink-0" style={{ width: 42, height: 52, borderRadius: 9, paddingBottom: 6, background: 'linear-gradient(180deg,#f4f4f6,#d9d9de)', boxShadow: '0 4px 10px var(--shade)' }}>
                <span style={{ fontSize: 8, fontWeight: 800, color: 'var(--bad)' }}>{endung.slice(0, 4).toUpperCase()}</span>
              </span>
              <span className="flex flex-col flex-1 min-w-0" style={{ gap: 2 }}>
                <span className="truncate" style={{ fontSize: 14, fontWeight: 800 }}>{d.titel || d.datei_name || 'Dokument'}</span>
                <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{[(d.kategorie ?? '').trim() || 'Ohne Kategorie', zuordnung, deDatum(d.created_at)].filter(Boolean).join(' · ')}</span>
              </span>
              {rechnungId ? <Receipt size={16} color="var(--acc)" /> : oeffnen ? <ArrowSquareOut size={16} color="var(--ink3)" /> : null}
            </button>
          );
        })}
      </div>
    </>
  );
}
